import {
  queryCategories,
  findClientRetailSpuByParam,
  searchFoundList,
  mallretailspu,
  queryBrandById
} from "@/api/product";
const state = {
  categoriesList: [
    {
      bannerImg: "",
      childrenCategories: [
        {
          bannerImg: "",
          name: "",
          id: "",
          resume: "",
          moduleImg: ""
        }
      ]
    }
  ],
  searchProductList: {
    rows: []
  },
  searchFoundList: [],
  searchKeys: [],
  mallretailspu: {
    description: {
      description: ""
    },
    name: "",
    skus: {},
    skuProps: [],
    brand: {
      name: ""
    },
    pictures: [],
    gift: [
      {
        spus: [
          {
            skus: {}
          }
        ]
      }
    ]
  },
  queryBrandById: {}
};

const mutations = {
  SET_CATEGORIESLIST(state, data) {
    state.categoriesList = data;
  },
  SET_SEARCHPRODUCTLIST(state, data) {
    if (data.pageNo === 0 || data.pageNo === 1) {
      state.searchProductList = data;
    } else {
      const data1 = state.searchProductList.rows;
      const data2 = data.rows;
      const rows = [...data1, ...data2];
      data.rows = rows;
      state.searchProductList = data;
    }
  },
  SET_SEARCHFOUNDLIST(state, data) {
    state.searchFoundList = data;
  },
  SET_QUERY_BRAND_BY_ID(state, data) {
    state.queryBrandById = data;
  },
  SET_SEARCH_KEYS: function(state, keys) {
    state.searchKeys = keys;
  },
  SET_MALLRETAILSPU: function(state, data) {
    if (data !== null) {
      const skuList = [];
      for (const item in data.skus) {
        data.skus[item].skuKey = item;
        skuList.push(data.skus[item]);
      }
      data.skuList = skuList;
      state.mallretailspu = data;
    } else {
      state.mallretailspu = null;
    }
  }
};

const actions = {
  // 分类列表
  async queryCategories({ commit }, { params }) {
    const response = await queryCategories(params);
    // console.log("分类列表", response);
    if (response.code === 1) {
      commit("SET_CATEGORIESLIST", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 搜索结果页
  async findClientRetailSpuByParam({ commit }, { params }) {
    // console.log(params);
    const response = await findClientRetailSpuByParam(params);
    // console.log("商品搜索结果", response);
    if (response.code === 1) {
      commit("SET_SEARCHPRODUCTLIST", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 搜索发现
  async searchFoundList({ commit }) {
    const response = await searchFoundList();
    // console.log("商品搜索发现", response);
    if (response.code === 1) {
      commit("SET_SEARCHFOUNDLIST", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 历史搜索
  async setSearchKeys({ commit }, { keywords }) {
    let str = localStorage.SEARCH_KEYS;
    if (str) {
      const keys = JSON.parse(str);
      const filters = keys.filter(key => key !== keywords);
      const newKeys = [keywords, ...filters];
      newKeys.splice(30);
      localStorage.SEARCH_KEYS = JSON.stringify(newKeys);
      commit("SET_SEARCH_KEYS", newKeys);
    } else {
      const keys = [keywords];
      localStorage.SEARCH_KEYS = JSON.stringify(keys);
      commit("SET_SEARCH_KEYS", keys);
    }
  },
  // 历史搜索初始化
  async initSearchKeys({ commit }, { keys, callback }) {
    commit("SET_SEARCH_KEYS", keys);
    callback();
  },
  // 商品详情
  async mallretailspu({ commit }, { params }) {
    const response = await mallretailspu(params);
    // console.log("商品详情", response);
    if (response.code === 1) {
      commit("SET_MALLRETAILSPU", response.data);
      return Promise.resolve();
    } else {
      // console.log(response.data, response.data);
      commit("SET_MALLRETAILSPU", response.data);
      return Promise.reject(response);
    }
  },
  // 商品详情
  async queryBrandById({ commit }, { params }) {
    const response = await queryBrandById(params);
    // console.log("品牌馆", response);
    if (response.code === 1) {
      commit("SET_QUERY_BRAND_BY_ID", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
